var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9972 20.0007C39.9972 30.102 32.5098 38.4529 22.7831 39.808C21.8736 39.9341 20.9431 40 19.9986 40C18.9083 40 17.8377 39.9131 16.7951 39.7449C7.27298 38.2118 0 29.9548 0 20.0007C0 8.95491 8.95459 0 20 0C31.0454 0 40 8.95491 40 20.0007H39.9972Z",
    fill: "#1C1C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11215 8.82025L17.3358 21.1525L8.05469 31.1795H10.1441L18.2705 22.4012L24.8358 31.1795H31.9448L22.2027 18.1535L30.842 8.82025H28.7526L21.2694 16.9049L15.2226 8.82025H8.11353H8.11215ZM11.1839 10.359H14.449L28.8703 29.6408H25.6051L11.1839 10.359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.1e41483d50b862bff31f33874e6f7d05.svg";
export { ForwardRef as ReactComponent };